////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Loading indicator — announced to assistive tech, not just shown //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

export interface SpinnerProps {
  label?: string;
}

export function Spinner ({ label = 'Loading' }: SpinnerProps) {
  return (
    <div role="status" className="flex items-center gap-3 text-muted">
      <span className="h-5 w-5 animate-spin rounded-full border-2 border-line border-t-ink" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
